import { render } from "./PropertyMap.vue?vue&type=template&id=511f53a2&scoped=true&ts=true"
import script from "./PropertyMap.vue?vue&type=script&lang=ts"
export * from "./PropertyMap.vue?vue&type=script&lang=ts"

import "./PropertyMap.vue?vue&type=style&index=0&id=511f53a2&lang=scss"
import "./PropertyMap.vue?vue&type=style&index=1&id=511f53a2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511f53a2"]])

export default __exports__